import { Injectable, signal } from '@angular/core';

export type AuthModalType = 'signin' | 'signup' | 'forgot-password' | null;

@Injectable({
  providedIn: 'root'
})
export class AuthModalService {
  // Signal to track which modal is open
  private modalTypeSignal = signal<AuthModalType>(null);
  
  // Signal to track where to redirect after success
  private redirectUrlSignal = signal<string | null>(null);
  
  // Public readonly signals
  modalType = this.modalTypeSignal.asReadonly();
  redirectUrl = this.redirectUrlSignal.asReadonly();

  openSignIn(redirectUrl: string | null = null) {
    this.redirectUrlSignal.set(redirectUrl);
    this.modalTypeSignal.set('signin');
  }

  openSignUp(redirectUrl: string | null = null) {
    this.redirectUrlSignal.set(redirectUrl);
    this.modalTypeSignal.set('signup');
  }

  openForgotPassword() {
    this.modalTypeSignal.set('forgot-password');
  }

  close() {
    this.modalTypeSignal.set(null);
    this.redirectUrlSignal.set(null);
  }

  isOpen(): boolean {
    return this.modalTypeSignal() !== null;
  }
}
